import { ShingleColorManager } from "@/components/admin/ShingleColorManager";

export default function ShingleColors() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Shingle Colors</h1>
        <p className="text-muted-foreground mt-2">
          Manage shingle color options for each product line
        </p>
      </div>

      <ShingleColorManager />
    </div>
  );
}
